import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import service from '../../../apis/service';
import { apiEndpoints } from '../../../constants/apiEndpoints';
import { ErrorToast } from '../../utils/Utils';
import { getDealershipList, showProgress } from '../../../redux/actions/DealershipActions';

const useFetchData = () => {
  const dispatch = useDispatch();
  const [dealershipHierarchyList, setDealershipHierarchyList] = useState([]);
  const [examList, setExamList] = useState([]);
  const getData = useCallback(async () => {
    dispatch(showProgress(true));
    try {
      const p1 = service.get(apiEndpoints.REPORT_DEALER_HIERARCHY);
      const p2 = service.get(apiEndpoints.REPORT_EXAMS_LIST);
      const p3 = service.get(apiEndpoints.GET_DEALERSHIPS);
      const responses = await Promise.all([p1, p2, p3]);
      setDealershipHierarchyList(responses[0] || []);
      setExamList(responses[1] || []);
      dispatch(getDealershipList('get', responses[2]));
    } catch (err) {
      ErrorToast(err);
    } finally {
      dispatch(showProgress(false));
    }
  }, [dispatch]);
  useEffect(() => {
    getData();
  }, [getData]);
  return { dealershipHierarchyList, examList };
};

export default useFetchData;
